<template>
  <div class="page flex-col">
    <div class="mod4 flex-col">
      <div
        class="flex-row align-center"
        style="padding: 15px 10px 15px 15px; border-bottom: 1px solid #ebebeb"
      >
        <div
          class="flexstartcenter marginRight cursonpinter"
          @click="$router.go(-1)"
        >
          <img
            src="@/assets/detail/go.png"
            style="width: 18px; margin-right: 5px"
          />
          <span style="font-size: 14px; color: #666">返回 </span>
        </div>
        <div class="flexstartcenter">
          <img
            src="@/assets/detail/i1.png"
            style="width: 20px; margin-right: 5px"
          />
          <span style="font-size: 14px; color: #666"
            >當前位置：藏書匯覽 \ {{ bookDetail.categoryName }} \
            <span style="color: #a8a8a8">{{ bookDetail.bookName }}</span>
          </span>
        </div>
      </div>
      <div class="flex-row" style="padding: 0px 60px">
        <div class="leftimgbox">
          <img :src="url + bookDetail.coverImageUrl" alt="" />
        </div>

        <div style="flex: 1">
          <div
            style="width: 100%; padding: 20px 20px 0px 10px"
            class="flex-col"
          >
            <span
              style="
                font-size: 25px;
                margin-bottom: 10px;
                font-weight: 600;
                color: #454545;
              "
              >{{ bookDetail.bookName }}
            </span>
            <div class="flex-row align-center">
              <div style="flex: 1" class="flex-col">
                <div class="flex-row" style="margin-top: 5px">
                  <span class="name">題名：</span>
                  <span class="value">{{ bookDetail.titleName }}</span>
                </div>
                <div class="flex-row" style="margin-top: 5px">
                  <span class="name">分類：</span>
                  <span class="value">{{ bookDetail.categoryName }}</span>
                </div>
                <div class="flex-row" style="margin-top: 5px">
                  <span class="name">作者：</span>
                  <span class="value">{{ bookDetail.charger }}</span>
                </div>
                <div class="flex-row" style="margin-top: 5px">
                  <span class="name">版本：</span>
                  <span class="value">{{ bookDetail.bookVersion }}</span>
                </div>

                <div class="flex-row" style="margin-top: 5px">
                  <span class="name">函冊：</span>
                  <span class="value">
                    {{ bookDetail.han }}
                  </span>
                  <!-- bookDetail.han
                        ? bookDetail.han + "函"
                        : "" + bookDetail.volume
                        ? bookDetail.volume + "冊"
                        : "" -->
                </div>
              </div>
            </div>
          </div>

          <div
            style="margin-top: 20px; margin-bottom: 20px; margin-left: 10px"
            @click="isShowShuZhi = !isShowShuZhi"
          >
            <div class="titlebutton">
              <img style="height: 20px" src="@/assets/detail/qy.png" />
              <span class="ftitle">書志</span>
            </div>
          </div>
          <div class="fcontent" v-if="isShowShuZhi">
            <p v-html="bookDetail.summary"></p>
          </div>
          <div v-if="!isShowShuZhi">
            <div style="padding: 15px 10px; border-bottom: 1px solid #ebebeb">
              <div class="title">
                <img style="height: 24px" src="@/assets/detail/read.png" />
                <span class="ftitle">閲讀 </span>
              </div>
            </div>
            <div>
              <ul class="celist celisttwo">
                <li
                  class="ce"
                  v-for="catdetail in catalogueList"
                  :key="catdetail.id"
                  @click="clickMenutwo(catdetail.id)"
                >
                  {{ catdetail.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isShowShuZhi" style="padding: 0 50px">
        <div
          style="padding: 15px 10px 15px 15px; border-bottom: 1px solid #ebebeb"
        >
          <div class="title">
            <img style="height: 24px" src="@/assets/detail/read.png" />
            <span class="ftitle">閲讀 </span>
          </div>
        </div>
        <div class="cebox">
          <ul class="celist">
            <li
              class="ce"
              v-for="catdetail in catalogueList"
              :key="catdetail.id"
              @click="clickMenutwo(catdetail.id)"
            >
              {{ catdetail.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ElImageViewer from '@/components/image-viewer.vue'
import merge from 'webpack-merge'
import {
  read,
  bookInfo,
  bookPage,
  essearch,
  booksTree,
  feedbackAdd
} from '@/api/api'


import $ from 'jquery'
import textPage from './com/textPage.vue'
import imagePage from './com/imagePage.vue'
import noData from './com/noData.vue'
export default {
  components: {
    ElImageViewer,
    textPage,
    imagePage,
    noData
  },
  data () {
    return {
      fxUrl: window.location.href.split('#')[0],
      // isFavor: false,
      loadingBookList: false,
      dialogVisible: false,
      showViewer: false,
      picList: [],
      url: window.__baseUrl__,
      isEdit: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      catalogueList: [], //目录数据
      axis: 'both', //拖动方向限制
      x: 0,
      y: 0,
      pb: '豎排',
      fy: '分页',
      zoom: 100,
      searchList: [],
      isLoading: false,
      pageList: [],
      form: {
        pageNum: 1,
        pageSize: 20,
        bookId: this.$route.query.id,
        bookText: ''
      },
      currentPage: 0,
      bookDetail: {},
      constants: {},
      title: '',
      mode: 1,
      page0: {},
      page1: {},
      bookId: 0,
      readPage: 0,
      totalPage: 0,
      token: "",
      img: "",
      singleType: 0,
      searchIndex: '',
      jumpTo: 0,
      remark: '',
      tooltipKey: 1,
      feedbackForm: {
        bookId: this.$route.query.id,
        feedbackPage: '',
        contentName: '',
        feedbackInfo: '',
      },
      feedbackFormRules: {
        contentName: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
        feedbackInfo: [{
          required: true,
          message: '请输入',
          trigger: 'blur'
        }],
      },
      isShowShuZhi: true,//书志是否展示
    }
  },
  created: function () {
    this.bookId = this.$route.query.id
    this.readPage = parseInt(this.$route.query.page)
    this.currentPage = this.readPage
    let bookId = this.bookId
    //书籍信息
    bookInfo({
      bookId
    }).then(res => {
      // console.log(res)
      this.bookDetail = res.data
      this.title = res.data.bookName
      // this.totalPage = res.data.imageUrls.length
      // this.initPage()
    })
    this.getBooksTree(this.$route.query.id)
    // this.queryIsFavor()
  },
  methods: {
    // clickMenu (type) {
    //   // }
    //   if (type === 2) {
    //     this.dialogVisible = true
    //   }
    //   if (type === 3) {
    //     this.$router.push({
    //       path: '/view',
    //       query: { ...this.$route.query, catId: this.catalogueList[0].id }
    //     })
    //   }
    // },
    clickMenutwo (catid) {
      // console.log('xxx')
      this.$router.push({
        // path: '/view',
        name: 'View',
        query: { ...this.$route.query, catId: catid, totalPage: this.bookDetail.totalPage }
      })

    },
    clickCommit () {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          this.feedbackForm.feedbackPage = this.$route.query.page
          feedbackAdd(this.feedbackForm).then((res) => {
            if (res.code === 200) {
              this.dialogVisible = false
              this.$message.success('提交成功')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    closeViewer () {
      document.body.style.overflow = 'auto'
      this.showViewer = false
    },
    showPrew (index) {
      document.body.style.overflow = 'hidden'
      this.showViewer = true
    },
    // queryIsFavor () {
    //   isFavor(this.$route.query.id).then((res) => {
    //     this.isFavor = res.isFavor
    //   })
    // },

    getBooksTree (id) {
      booksTree({
        parentId: id,
        nodeType: 'book',
      }).then(res => {
        this.catalogueList = res.data
      })
    },
    loadNode (node, resolve) {
      // console.log(node)
      booksTree({
        parentId: node.data.id,
        nodeType: 'book',
      }).then(res => {
        if (res.data && res.data.length > 0) {
          resolve(res.data)
        } else {
          resolve([])
        }
      })
    },

    switchSingle (type) {
      this.singleType = type
      this.initPage()
    },
    singleChange () {
      this.readPage = this.readPage + 1
      this.initPage()
    },
    back () {
      this.searchList = []
      this.form.bookText = ''
    },
    change (e) {
      this.loadingBookList = true
      essearch(this.form).then((res) => {
        res.data.map((item) => {
          if (item.pageText) {
            item.pageText = item.pageText.replaceAll('一', '').replaceAll('\\n', '')
            item.pageText = item.pageText.replaceAll(this.form.bookText,
              `<span style="color:red">${this.form.bookText}</span>`)
          } else {
            item.pageText = ''
          }
        })
        this.searchList = res.data
        this.loadingBookList = false
        this.$nextTick(() => {
          document.body.scrollTop = 0
        })
      })
    },
    prevPage: function () {
      if (this.readPage == 1) {
        alert('已经是第一页')
        return false
      }
      this.readPage = this.readPage - 1 - this.singleType
      this.currentPage = this.readPage
      this.initPage()
    },
    nextPage: function () {
      if (this.readPage == this.totalPage) {
        alert('已经是最后一页')
        return false
      }
      this.readPage = this.readPage + 1 + this.singleType
      this.currentPage = this.readPage
      this.initPage()
    },
    toPageNum: function (index, e) {
      this.searchIndex = index
      this.currentPage = e
      this.onSubmit()
    },
    onSubmit: function () {
      const pageNum = parseInt(this.currentPage)
      if (pageNum <= this.totalPage && pageNum >= 0) {
        this.readPage = pageNum
        this.initPage()
      } else {

      }
    },
    initPage: function () {
      if (parseInt(this.$route.query.page) !== parseInt(this.readPage)) {
        this.$router.push({
          query: merge({}, {
            id: this.$route.query.id,
            catId: this.catalogueList[0].id,
            page: this.readPage,
          })
        })
      }
      this.isLoading = true
      this.pageList = []
      let readPage = this.readPage
      let bookId = this.bookId
      let token = this.token

      // this.picList = [this.url + this.bookDetail.imageUrls[this.readPage - 1]]

      // //阅读记录
      // read({
      //   bookId,
      //   readPage: readPage,
      //   token
      // })
      //书页信息
      bookPage({
        bookId,
        token,
        startPage: this.fy === '连续' && this.mode === 3 ? 1 : readPage,
        endPage: this.fy === '连续' && this.mode === 3 ? this.totalPage : (readPage + this.singleType)
      }).then(res => {
        this.jumpTo = res.data[0].jumpTo
        this.remark = res.data[0].remark
        res.data.map((page) => {
          if (page.pageJson) {
            // 获取当前页面文字坐标信息
            const list = JSON.parse(page.pageJson)
            const textList = []
            list.forEach(item => {
              if (item.text != '一') {
                textList.push(item)
              }
            })
            page.list = textList
          } else {
            page.list = []
          }
          page.notes.map((note) => {
            note.style = JSON.parse(note.notePos)
          })
        })
        this.pageList = res.data
        this.$nextTick(() => {
          this.isLoading = false
        })
        // console.log(this.pageList)
      })
    }
  },
};
</script>
<style scoped lang="less">
.flexstartcenter {
  display: flex;
  align-items: center;
}
::-webkit-scrollbar-thumb {
  height: 10px; /* 滚动条滑块长度 */
  // background-color: #ccc;
}
.marginRight {
  margin-right: 30px;
}
.cursonpinter {
  cursor: pointer;
}
.titlebutton {
  width: 80px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #454545;
  cursor: pointer;
  img {
    margin-right: 5px;
  }
}
.titlebutton:hover {
  color: #aa1d1f;
  border-color: #aa1d1f;
}
.title {
  width: 80px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #454545;
  img {
    margin-right: 5px;
  }
}
.leftimgbox {
  padding: 20px 80px 20px 0;
  text-align: center;
  width: 430px;
  img {
    width: 350px;
    height: 500px;
  }
}
.ftitle {
  // margin-left: 10px;
  font-size: 18px;
  // font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}

.fcontent {
  white-space: pre-wrap;
  font-size: 16px;
  line-height: 2;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #454545;
  text-align: justify;
  padding: 0 16px;
  max-height: 31vh;
  overflow-y: auto;
}

.name {
  font-size: 15px;
  color: #6e6d6d;
}

.value {
  font-size: 15px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #454545;
}

.menubg {
  height: 50px;
  padding-left: 10px;
  margin-top: 10px;
  background: url("../assets/detail/xy.png") 0rem 0rem no-repeat;
  background-size: 100% 100%;
}

.menu_item {
  cursor: pointer;
  margin-right: 30px;
}

.menu_item span {
  font-size: 15px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-left: 5px;
  color: #262626;
}

.page_left {
  width: 1.2rem;
  height: 1.2rem;
  background: url("../assets/img/icon_left.png") -0.027rem 0rem no-repeat;
  background-size: 1.227rem 1.2rem;
  margin-top: 5.4rem;
}

.page_left:hover {
  opacity: 0.79;
}

.page_right {
  width: 1.2rem;
  height: 1.2rem;
  background: url("../assets/img/icon_right.png") -0.027rem 0rem no-repeat;
  background-size: 1.227rem 1.2rem;
  margin: 5.4rem 0 0 1.174rem;
}

.page_right:hover {
  opacity: 0.79;
}

.page {
  /* position: relative; */
  // height: 24.5rem;
  /* background-color: rgba(245, 245, 245, 1); */
  overflow: hidden;
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;
  flex-direction: row;
  height: 86.3vh;
  overflow: hidden;
}
.cebox {
  height: 11vh;
  overflow-y: auto;
}

.mod4 {
  overflow: hidden;
  z-index: 0;
  /* width: 32rem !important; */
  // width: 94%;
  width: 1500px;
  min-height: 86vh;
  // height: 22.5rem;
  background: rgba(245, 245, 245, 1);
  // overflow: hidden;
  /* width: 12rem; */
  /* position: absolute;
  left: 3.2rem;
  top: 1.014rem; */

  .celist {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    padding: 10px 0;
    cursor: pointer;
    li {
      width: 25%;
      // font-size: 16px;
      // margin: 20px;
    }
    .ce {
      font-size: 16px;
      // margin: 10px 120px 10px 20px;
      padding: 10px 15px;
      display: flex;
      // justify-content: center;
      align-items: flex-start;
      align-items: center;
      // flex-wrap: wrap;
    }
  }
  .celisttwo {
    max-height: 46vh;
    overflow-y: auto;
  }
}

.outer1 {
  width: 100% !important;
  height: 10.854rem !important;
}

.outer3 {
  z-index: 126;
  border-radius: 9px;
  background-color: #f3f3f3;
  width: 100%;
  height: 100%;
  position: relative;
}

.layer6 {
  width: 100%;
}

.mod6 {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail.vue